
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteBlockgroupOnScenario",
      resolverType: "mutation",
      routePath: "/deleteBlockgroupOnScenario",
      httpMethod: "POST",
    });
  